var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/createMapStateToProps/createMapStateToProps.ts
import { createSelector } from "reselect";
import isEmpty from "lodash.isempty";
import dot from "dot-object";
var createMapStateToProps = (selectors) => (map, defaults = {}) => {
  const dotNotationMap = dot.dot(map);
  const stateMappedToSelectors = Object.entries(dotNotationMap).reduce((props, [destination, target]) => {
    const [source, selector = false] = target.split(STATE_SEPARATOR);
    const inputs = source.split(",");
    return __spreadProps(__spreadValues({}, props), {
      [destination]: createSelector(inputs.map((input) => (state) => input.startsWith("!") ? input.substring(1) : dot.pick(input, state)), selector && !isEmpty(selectors) ? selectors[selector] : (value) => value)
    });
  }, dot.dot(defaults));
  return (state) => {
    const stateMappedToProps = dot.object(Object.entries(stateMappedToSelectors).reduce((stateMappedToProps2, [destination, value]) => __spreadProps(__spreadValues({}, stateMappedToProps2), {
      [destination]: typeof value === "function" ? value(state) : value
    }), {}));
    if (stateMappedToProps[0]) {
      return Object.values(stateMappedToProps);
    }
    return stateMappedToProps;
  };
};
var createMapStateToProps_default = createMapStateToProps;

// src/mergeProps/mergeProps.ts
import merge from "deepmerge";
var mergeProps = (stateProps, dispatchProps, ownProps) => merge.all([ownProps, stateProps, dispatchProps]);
var mergeProps_default = mergeProps;

// src/componentParser/componentParser.ts
var componentParser = (componentPlugins = {}, defaultPlugin) => (componentJSON, Element, internalProperties) => {
  const parser = componentPlugins[componentJSON.__component] || defaultPlugin;
  if (!componentPlugins || !parser) {
    return Element;
  }
  if (Array.isArray(parser)) {
    return parser.reduce((total, singleParser) => {
      return singleParser(componentJSON, total, internalProperties);
    }, Element);
  }
  return parser(componentJSON, Element, internalProperties);
};
var componentParser_default = componentParser;

// src/index.ts
var STATE_SEPARATOR = "|";
export {
  STATE_SEPARATOR,
  componentParser_default as componentParser,
  createMapStateToProps_default as createMapStateToProps,
  mergeProps_default as mergeProps
};
